import React, {useEffect, useState } from "react";
//import * as React from 'react';

import { useList, useObject } from 'react-firebase-hooks/database';
import { useHistory } from "react-router";
import { auth, db, logout, firebase_get_device_client_title, firebase_assign_device_to_client, firebase_update_device_status,  firebase_share_device_to_client, firebase_delete_device, firebase_delete_client_from_device_shares, firebase_update_device, firebase_update_device_test, firebase_update_device_gas_active, firebase_get_device_logs, firebase_update_backup_logs,firebase_update_device_management, firebase_get_email_configuration, firebase_update_email_configuration} from "./firebase";
import moment from "moment-timezone";

import dayjs from 'dayjs';

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
//import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';


import Level from "./guages/level";
import Pressure from "./guages/pressure";
import Temp from "./guages/temp";
import Heat from "./guages/heat";
import GasLeak from "./guages/gasleak";
import Vaporizer from "./guages/vaporizer";

import { useLocation } from 'react-router-dom';

import { Form, Field } from 'react-final-form';
import { FieldArray } from "react-final-form-arrays";
import arrayMutators from 'final-form-arrays'

import { DatePicker } from "@mui/x-date-pickers/DatePicker";


import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import Snackbar from '@mui/material/Snackbar';
import Avatar from '@mui/material/Avatar';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import Autocomplete from '@mui/material/Autocomplete';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PersonIcon from '@mui/icons-material/Person';
import Tooltip from '@mui/material/Tooltip';

import Divider from '@mui/material/Divider';


import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import ShareIcon from '@mui/icons-material/Share';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import ContactMailIcon from '@mui/icons-material/ContactMail';



import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import DeviceStatus from "./DeviceStatus";
import DeviceChart from "./DeviceChart";
//import DeviceChartToday from "./DeviceChartToday";

import PressureSetting from "./settings/PressureSetting";
import GasLeakSetting from "./settings/GasLeakSetting";
import TemperatureSetting from "./settings/TemperatureSetting";
import HeatSetting from "./settings/HeatSetting";
import VaporizerSetting from "./settings/VaporizerSetting";
import LevelSetting from "./settings/LevelSetting";


import Styles from './Styles';

import {styled} from "@mui/system";
import { IconButton } from "@mui/material";
import { useTheme, useMediaQuery } from '@material-ui/core';

import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { DateRangePicker, DateRange } from 'react-date-range';
import { addDays } from 'date-fns';

import LINELogo from './images/LINE_logo.svg';
import BackupIcon from './images/backup.svg';

import CheckboxTree from 'react-checkbox-tree';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';

function Device(props) {
  const theme = useTheme();
  const isMD = useMediaQuery(theme.breakpoints.down('md'));
  const isLG = useMediaQuery(theme.breakpoints.down('lg'));
  const isSM = useMediaQuery(theme.breakpoints.down('sm'));

  const history = useHistory();

  const location = useLocation();
  const deviceId = location.state.deviceId;
  const uid = location.state.uid;

  const r = '/devices/' + deviceId;


  const [device_snapshot, loading_device, error_db] = useObject(db.ref(r));
  const [clients_snapshot, loading_clients] = useList(db.ref('/clients'));

  const [device, setDevice] = useState();
  const [clients, setClients] = useState([]);
  const [deviceShares, setDeviceShares] = useState([]);
  const [deviceManagement, setDeviceManagement] = useState([]);


  const [assignClient, setAssignClient] = useState();
  const [shareClient, setShareClient] = useState();

  const [clientTitle, setClientTitle] = useState();

  const [openShareSnackbar, setOpenShareSnackbar] = useState(false);
  const [shareSnackbarMessage, setShareSnackbarMessage] = useState("");

  const [openDeleteSnackbar, setOpenDeleteSnackbar] = useState(false)
  const [deleteSnackbarMessage, setDeleteSnackbarMessage] = useState("");

  const [selectStartChartDate, setSelectStartChartDate] = useState(moment());
  const [selectEndChartDate, setSelectEndChartDate] = useState(moment());
  const [chartDateRange, setChartDateRange] = useState([
    {
      startDate: moment().toDate(),
      endDate: moment().toDate(),
      key: 'selection'
    }
  ]);

  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [openShareClient, setOpenShareClient] = useState(false);
  const [openEditDevice, setOpenEditDevice] = useState(false);
  const [openShareClientList, setOpenShareClientList] = useState(false);
  const [openAssignClient, setOpenAssignClient] = useState(false);
  const [openDeleteClientFromDeviceShares, setOpenDeleteClientFromDeviceShares] = useState(false);

  const [gasActiveCommand, setGasActiveCommand] = useState("OFF");

  const [deviceTitle, setDeviceTitle] = useState();
  const [deviceDescription, setDeviceDescription] = useState();

  const [lineAPIToken, setLineAPIToken] = useState();
  const [openLINEAPI, setOpenLINEAPI] = useState(false);
  const [openBackupData, setOpenBackupData] = useState(false);
  const [openEmailList, setOpenEmailList] = useState(false);


  const [plotLevel, setPlotLevel] = useState(false);
  const [plotP1, setPlotP1] = useState(false);
  const [plotP2, setPlotP2] = useState(false);
  const [plotTemp, setPlotTemp] = useState(false);
  const [plotR1, setPlotR1] = useState(false);
  const [plotR2, setPlotR2] = useState(false);

  const [deviceLogs, setDeviceLogs] = useState();
  const [deviceReLogs, setDeviceReLogs] = useState();
  const [deviceKLogs, setDeviceKLogs] = useState();

  const [deviceEmailConfiguration, setDeviceEmailConfiguration] = useState([]);

  const [isAdmin, setIsAdmin] = useState((sessionStorage.getItem("admin")=='true') || (sessionStorage.getItem("power_user")=='true'));

  const LinkButton = styled(Button)({
    textTransform: 'none',
  });

  const [logCheck, setLogCheck] = useState([]);
  const [logExpand, setLogExpand] = useState([]);

  const [currentTabIndex, setCurrentTabIndex] = useState(0);

  useEffect(async () => {
      /*snapshots.map(device => {
        //console.log(device.key);
        //console.log(device.val().current_status.pressures.p1.value);
        device_data.push(
          {
            id: device.key,
            title: device.val().title,
            client: device.val().client,
            current_status: device.val().current_status,
            status: device.val().status,
          }
        );
      })*/
      if(device_snapshot && !loading_device)
      {
        /*setPlotLevel(device_snapshot.val().sensor_info.level.hardware_status=='installed');
        setPlotP1(device_snapshot.val().sensor_info.pressure.p1.hardware_status=='installed');
        setPlotP2(device_snapshot.val().sensor_info.pressure.p2.hardware_status=='installed');
        setPlotTemp(device_snapshot.val().sensor_info.temperature.t1.hardware_status=='installed');
        setPlotR1(device_snapshot.val().sensor_info.relay.r1.hardware_status=='installed');
        setPlotR2(device_snapshot.val().sensor_info.relay.r2.hardware_status=='installed');
        console.log("PLOT LEVEL FROM DEVICE1 :: " + device_snapshot.val().sensor_info.level.hardware_status);
        console.log("PLOT LEVEL FROM DEVICE2 :: " + plotLevel);
        console.log("PLOT TEMP FROM DEVICE1 :: " + device_snapshot.val().sensor_info.temperature.t1.hardware_status);
        console.log("PLOT TEMP FROM DEVICE2 :: " + plotTemp);*/

        setDevice(device_snapshot.val());
        setDeviceTitle(device_snapshot.val().title);
        setDeviceDescription(device_snapshot.val().desc)
        setLineAPIToken(device_snapshot.val().client.line_api_key);
        setGasActiveCommand(device_snapshot.val().current_status.gas_active);
        setClientTitle(await firebase_get_device_client_title(device_snapshot.val().client.id));

        setDeviceManagement(device_snapshot.val().management);
        // convert shared clients to array
        var sc = [];
        if(device_snapshot.val()['shares'])
        {
          Object.keys(device_snapshot.val()['shares']).forEach(key =>{
            var c = {};
            c.id = key;
            c.title = device_snapshot.val()['shares'][key].title;
            c.username = device_snapshot.val()['shares'][key].username;
            sc.push(c);
          });
        }
        setDeviceShares(sc);
        /*Object.keys(device_snapshot.val()['shares']).forEach(key => {
          console.log(key)
        })*/
      }
      if(clients_snapshot && !loading_clients)
      {
        var c = [];
        clients_snapshot.map(client => {
          var cl = {};
          cl.id = client.key;
          cl.label = client.val().username;
          cl.username = client.val().username;
          cl.title = client.val().info.title;
          cl.type = client.val().type;
          c.push(cl);
        });
        setClients(c);
        //console.log(c)
      }
  }, [device_snapshot, loading_device, clients_snapshot, loading_clients]);

  const Disabled = ({ disabled, children }) => {
    if (disabled) {
      return (
        <div style={{ opacity: 0.3, pointerEvents: "none" }} disabled>
          {children}
        </div>
      );
    }
    return <React.Fragment>{children}</React.Fragment>;
  }

  if (loading_device)
  {
    return (<div style={{alignItems: "center", display: 'flex', justifyContent: 'center', height: "100vh", width: "100vw" }}>
            <Box sx={{ display: 'flex' }}>
              <Typography variant="caption" style={{textAlign: "center"}} component="div" color="text.secondary">
                <CircularProgress /><br />
                Loading LPG device data...
              </Typography>
            </Box>
            </div>);
  }

  if (loading_clients)
  {
    return (<div style={{alignItems: "center", display: 'flex', justifyContent: 'center', height: "100vh", width: "100vw" }}>
            <Box sx={{ display: 'flex' }}>
              <Typography variant="caption" style={{textAlign: "center"}} component="div" color="text.secondary">
                <CircularProgress /><br />
                Loading all clients data...
              </Typography>
            </Box>
            </div>);
  }

const handleGasActiveCommand = async (
    event: React.MouseEvent<HTMLElement>,
    newGasActiveCommand: string,
  ) => {
    await firebase_update_device_gas_active(deviceId, {
      "gas_active": newGasActiveCommand
    });
    setGasActiveCommand(newGasActiveCommand);
  };

const handleOpenAssignClient = () => {
    setOpenAssignClient(true);
  };

const handleCloseAssignClient = () => {
    setOpenAssignClient(false);
  };

const handleAssignClient = () => {
    //console.log(assignClient)
    if(assignClient != null)
    {
      firebase_assign_device_to_client(deviceId, device.title, device.client.id, assignClient.id, assignClient.title, assignClient.username);
      setOpenAssignClient(false);
    }
  };

const handleClientChange = (e, value) => {
  setAssignClient(value);
}

const handleOpenEditDevice = () => {
  setOpenEditDevice(true);
};

const handleCloseEditDevice = () => {
  setOpenEditDevice(false);
};

const onSubmitDeviceTitleDesc = async values => {
  //window.alert(JSON.stringify(values,0,2))
  await firebase_update_device(deviceId, values);
  //await firebase_update_device_test('-MYCKaK4v4P9wkXC14Ur', values);
  setOpenEditDevice(false);
}

const onSubmitEmailList = async values => {
  //window.alert(JSON.stringify(values,0,2))
  //console.log(values);
  await firebase_update_email_configuration(deviceId, values);
  setOpenEmailList(false);
}

const handleOpenShareClient = () => {
  setShareClient(null);
  setOpenShareClient(true);
};

const handleCloseShareClient = () => {
  setOpenShareClient(false);
};

const handleShareClient = () => {
  var sc = null;
  if(typeof shareClient === 'object')
  {
    sc = shareClient.username;
  }
  else
  {
    sc = shareClient;
  }

  if(sc != null)
  {
    var checkClient = clients.filter(client => client.username.includes(sc));
    
    if(checkClient.length > 0)
    {
      //console.log(checkClient)
      firebase_share_device_to_client(deviceId, checkClient[0].id, checkClient[0].title, checkClient[0].username);
      //setOpenShareClient(false);
      setShareSnackbarMessage("Device has been shared to " + checkClient[0].username);
      setShareClient(null);
      setOpenShareSnackbar(true);
    }
    else
    {  
        setShareSnackbarMessage("Client email \'" + sc + "\' not found!");
        setOpenShareSnackbar(true);
    
    }
  }
  else
  {
    setShareSnackbarMessage("Client email cannot be empty!");
    setOpenShareSnackbar(true);
  }
};

const handleShareClientChange = (e, value) => {
  setShareClient(value);
}

const handleShareClientByOwnerChange = (e) => {
  setShareClient(e.target.value);
}

const handleOpenDeleteConfirm = () => {
    setOpenDeleteConfirm(true);
  };

const handleCloseDeleteConfirm = () => {
    setOpenDeleteConfirm(false);
  };

const handleConfirmDelete = () => {
    firebase_delete_device(deviceId);
    setOpenDeleteConfirm(false);
    history.push(
      { 
        pathname: '/devices',
      });
  };

  const handleOpenDeleteClientFromDeviceShares = () => {
    setOpenDeleteClientFromDeviceShares(true);
  };

const handleCloseDeleteClientFromDeviceShares = () => {
    setOpenDeleteClientFromDeviceShares(false);
  };

const handleDeleteClientFromDeviceShares = async (clientId) => {
    console.log(await firebase_delete_client_from_device_shares(deviceId, clientId));
    setShareSnackbarMessage("Remove client from sharing this device successfully")
    setOpenShareSnackbar(true);
    setOpenDeleteClientFromDeviceShares(false);
  };

const handleCloseShareSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenShareSnackbar(false);
  };

const handleCloseDeleteSnackbar = (event, reason) => {
  if (reason === 'clickaway') {
    return;
  }
}

const showClient = (uid) => {
    history.push(
        { pathname: '/client',
          state: {
              uid: uid,
          }
        });
}

const handleSetLINEAPI = (e) =>
{
  firebase_update_device(deviceId + "/client", {"line_api_key": lineAPIToken});
  setOpenLINEAPI(false);
}

const handleOpenLINEAPI = () =>
{
  setOpenLINEAPI(true);
}

const handleCloseLINEAPI = () => {
  setLineAPIToken(device.client.line_api_key);
  setOpenLINEAPI(false);
};


const handleOpenBackupData = async () =>
{
  // read data structure from firebase
  var logs = await firebase_get_device_logs(deviceId);
  //console.log(logs);
  var yl = [];
  var chks = [];
  var rlogs = {};
  var klogs = {};
  logs.map(log => {
    log.children.map(chk => 
    {
      //console.log(chk)
      chks.push(chk.value);
    });
    yl.push(log.value);
    var rl = {};
    rlogs[log.value] = log.data;
  });
  
  //setDeviceLogYears(yl);
  setLogExpand(yl);

  if(chks.length > 3)
  {
    chks.pop();
    chks.pop();
    chks.pop();
  }
  else
  {
    chks = [];
  }

  setLogCheck(chks);
  
  setDeviceLogs(logs);

  //console.log(logs)
  //const keys = Object.keys(rlogs);
  
  logs.map(year => {
    var kk = {};
    for (const [key, value] of Object.entries(year.data)) {
      //console.log(key)
      //console.log(value)
      if(!chks.includes(year.value + key))
      {
        kk[key] = value;
      }
    }
    if(Object.keys(kk).length > 0)
    {
      klogs[year.value] = kk;
    }
  }) 

  setDeviceReLogs(rlogs);
  setDeviceKLogs(klogs);
  //for (var n = 0 ; n < deviceLogs.length ; n++) {
  //  delete deviceLogs[n].children;
  //}
  //console.log(rlogs)
  setOpenBackupData(true);
}


const handleCloseBackupData = () =>
{
  setOpenBackupData(false);
}

const handleSaveBackupData = async () =>
{
  await downloadLogFile();
  await updateLogData();
  setOpenBackupData(false);
}

const downloadLogFile = async () => {
  // create file in browser
  var now = moment();
  const fileName = "device_" + deviceId + "_export_" + now.format("DD-MM-YYYY_HHmmss");
  const json = JSON.stringify(deviceReLogs, null, 2);
  const blob = new Blob([json], { type: "application/json" });
  const href = URL.createObjectURL(blob);

  // create "a" HTLM element with href to file
  const link = document.createElement("a");
  link.href = href;
  link.download = fileName + ".json";
  document.body.appendChild(link);
  link.click();

  // clean up "a" element & remove ObjectURL
  document.body.removeChild(link);
  URL.revokeObjectURL(href);
}

const updateLogData = async () => {
  await firebase_update_backup_logs(deviceId, deviceKLogs);
}

const handleTabChange = (e, tabIndex) => {
  //console.log(tabIndex);
  setCurrentTabIndex(tabIndex);
};

const onSubmitDeviceManagement = async (values) => {
  /*console.log(values.device)
  console.log({
    "installation_date": values.installationDate.toString(),
    "due_date": values.dueDate.toString(),
    "payment_date": values.paymentDate.toString(),
    "note": values.note
  })*/
  return firebase_update_device_management(values.deviceId, 
    {
      "installation_date": values.installationDate.toString(),
      "due_date": values.dueDate.toString(),
      "payment_date": values.paymentDate.toString(),
      "note": values.note
    });
  //await firebase_update_device_test('-MYCKaK4v4P9wkXC14Ur', values);
  //setOpenEditDevice(false);
}

const mustBeValidDateTime = (value) => {
  return value?.format().includes("Invalid date")
    ? "Must be a valid DateTime"
    : undefined;
};

const displayDevice = () =>
{
  if(device)
  {
    return <Container maxWidth="xl" >
            <Grid container spacing={2} sx={{pt: 10, pl:2, pr:2, pb:2}}>
            </Grid>
            <Tabs value={currentTabIndex} onChange={handleTabChange}>
              <Tab label="Details" />
              <Tab label="Management" disabled={isAdmin ? false : true}  />
            </Tabs>
              {currentTabIndex === 0 && (
              <Paper elevation={2} sx={{p: 3}}>
              <Grid container spacing={1}>  
                <Grid item xs={12} md={5}>
                  <Grid container spacing={2}>  
                          <Grid item xs={8}>
                            <Grid container direction={'column'} spacing={3}>
                              <Grid item>
                                <Typography variant="h6" component="div">
                                Gas Monitoring {(sessionStorage.getItem("power_user") == "true") && <Typography variant="caption">
                                  {deviceId} <IconButton onClick={handleOpenBackupData}><img
                                  src={BackupIcon}
                                  alt={"Backup data for this device"}
                                  loading="lazy"
                                  style={
                                    {
                                      width: 30,
                                      height: 30,
                                    }
                                  }
                                /></IconButton>
                                </Typography>}
                                </Typography>
                                <Stack alignItems="center" sx={{ mt: 1 }} direction="row" spacing={1}>
                                <Typography color="info">
                                {device.title}</Typography>                                
                                <Tooltip title="Edit device title & description" arrow>
                                <IconButton disabled={((device.client.id == uid) || isAdmin) ? false : true} onClick={handleOpenEditDevice}>
                                  <EditIcon />
                                </IconButton>
                                </Tooltip>
                                <Disabled disabled={!isAdmin}>
                                <IconButton disabled={isAdmin ? false : true} onClick={handleOpenLINEAPI}>
                                <img
                                  src={LINELogo}
                                  alt={"LINE API Key"}
                                  loading="lazy"
                                  style={
                                    {
                                      width: 30,
                                      height: 30,
                                    }
                                  }
                                />
                                </IconButton>
                                </Disabled>
                                <Tooltip title="Share this device" arrow>
                                <Disabled disabled={(!device.client.id == uid) && !isAdmin}>
                                <IconButton disabled={((device.client.id == uid) || isAdmin) ? false : true} onClick={handleOpenShareClient}>
                                  <ShareIcon />
                                </IconButton>
                                </Disabled>
                                </Tooltip>
                          
                                </Stack>
                                <Tooltip title="Owner of this device" arrow>
                                <Typography sx={{ mb: 1.5 }}>by {clientTitle ? <LinkButton onClick={((device.client.id == uid) || isAdmin) ? e => showClient(device.client.id) : undefined}>{clientTitle}</LinkButton> : "Unassigned"}
                                </Typography>
                                </Tooltip>
                                <Typography variant="body2" sx={{ mb: 1.5 }}>
                                  {device.desc}
                                </Typography>                                
                                <Box sx={{pt: 1}} />
                                <Stack direction="row" spacing={1}>
                                  {displayActivateStatus()}{displayOnlineStatus()}{displayEmailStatus()}
                                </Stack>
                                <Box sx={{p: 1}} />
                                <Stack direction="row" spacing={1}>
                                  <Tooltip title="Assign this device to client" arrow>
                                  <Button 
                                    disabled={!(sessionStorage.getItem("power_user") == "true")}
                                    onClick={handleOpenAssignClient} color="success" variant="contained" size="small" startIcon={<AssignmentTurnedInIcon /> }>
                                      Assign
                                  </Button>
                                  </Tooltip>
                                  <Tooltip title="Delete this device!" arrow>
                                  <Button 
                                    disabled={!(sessionStorage.getItem("power_user") == "true")}
                                    onClick={handleOpenDeleteConfirm} color="error" variant="contained" size="small" startIcon={<DeleteIcon /> }>
                                      Delete
                                  </Button>
                                  </Tooltip>
                                </Stack>
                                <Box sx={{p: 1}} />
                                <Dialog
                                  PaperProps={{
                                    sx: {
                                      width: "100%",
                                    }
                                  }}
                                  open={openBackupData} onClose={handleCloseBackupData}>
                                  <DialogTitle>Backup Firebase Data</DialogTitle>
                                  <DialogContent>
                                    <DialogContentText>
                                      All device data logs will be downloaded and displayed. This could take a long time to download depend on size of data remains on the server. This operation will then ask for backing up and deleting data from Firebase server. Default backup will keep the latest 3 months of data on the Firebase database and download the older data to local backup with deletion. Months of data to be backed up and then deleted are checked with {'\u2713'} while months of data to keep on server are not checked. This cannot be undone so please proceed with caution. <span>{<br/>}</span>
                                    </DialogContentText>
                                    <Box />
                                    <CheckboxTree
                                        nodes={deviceLogs}
                                        checked={logCheck}
                                        expanded={logExpand}
                                        onCheck={checked => {
                                            //console.log(checked)
                                            setLogCheck(checked)
                                          }}
                                        onExpand={expanded => {
                                            //console.log(expanded)
                                            setLogExpand(expanded)      
                                          }}
                                    />
                                    {/*
                                    <TreeView
                                      aria-label="delete firebase data"
                                      defaultCollapseIcon={<ExpandMoreIcon />}
                                      defaultExpandIcon={<ChevronRightIcon />}
                                      expanded={deviceLogYears}
                                      sx={{ pt: 2, height: 240, flexGrow: 1, maxWidth: 400}}
                                      onNodeSelect={handleSelectBackup}
                                    >
                                      { deviceLogs && 
                                        deviceLogs.map(log => (                                        
                                          <TreeItem nodeId={log.year} label={log.year}>
                                            {
                                              log.month.map(mth => (
                                                <TreeItem nodeId={log.year + ":" + mth.number} label={mth.status + " " + mth.title } />
                                              ))
                                            }
                                          </TreeItem>
                                        ))
                                      }
                                    </TreeView> */}
                                  </DialogContent>
                                  <DialogActions>
                                    <Button onClick={handleCloseBackupData}>Cancel</Button>
                                    <Button onClick={handleSaveBackupData}>OK</Button>
                                  </DialogActions>
                                </Dialog>
                                <Dialog
                                  PaperProps={{
                                    sx: {
                                      width: "100%",
                                    }
                                  }}
                                  open={openEditDevice} onClose={handleCloseEditDevice}>
                                  <DialogTitle>Edit Device Title & Description</DialogTitle>
                                  <DialogContent>
                                    <DialogContentText>
                                      Device owner can edit device title and description.
                                    </DialogContentText>                                    
                                    <Styles>
                                      <Form
                                          onSubmit={onSubmitDeviceTitleDesc}
                                          initialValues={{
                                                          title: device.title,
                                                          desc: device.desc,                       
                                                        }}
                                          render={({ handleSubmit, form, submitting, pristine, values }) => (
                                              <form onSubmit={handleSubmit}>
                                              <div>
                                                  <label>Device Title</label>
                                                  <Field
                                                  name="title"
                                                  component="input"
                                                  type="text"
                                                  placeholder="Food Hub"
                                                  />
                                              </div>   
                                              <div>
                                                  <label>Description</label>
                                                  <Field
                                                  name="desc"
                                                  component="input"
                                                  type="text"
                                                  placeholder="@Siam Square"
                                                  />
                                              </div>                  
                                              

                                              <div className="buttons">
                                                  <button type="submit" disabled={submitting || pristine}>
                                                      Update Device Info
                                                  </button>
                                                  <button
                                                  type="button"
                                                  onClick={form.reset}
                                                  disabled={submitting || pristine}
                                                  >
                                                  Reset
                                                  </button>
                                                  <button
                                                  type="button"
                                                  onClick={handleCloseEditDevice}
                                                  >
                                                  Cancel
                                                  </button>
                                              </div>
                                              {/*<pre>{JSON.stringify(values, 0, 2)}</pre>*/}
                                              </form>
                                          )}
                                          />
                                          </Styles>
                                  </DialogContent>
                                </Dialog>
                                <Dialog
                                  PaperProps={{
                                    sx: {
                                      width: "100%",
                                    }
                                  }}
                                  open={openLINEAPI} onClose={handleCloseLINEAPI}>
                                  <DialogTitle>Enter LINE API Token</DialogTitle>
                                  <DialogContent>
                                    <DialogContentText>
                                      Enter LINE API token for receiving status of LPG devices through LINE application (all platform).
                                    </DialogContentText>
                                    
                                    <TextField
                                      style={{
                                        width: '100%',
                                        marginTop: 20,
                                      }}
                                      id="outlined-line-api-token"
                                      label="LINE API Token"
                                      helperText="This is for admin user only..."
                                      value={lineAPIToken}
                                      onChange={(e)=> {
                                        setLineAPIToken(e.target.value)
                                        //console.log(e.target.value)
                                      }}
                                    />
                                  </DialogContent>
                                  <DialogActions>
                                    <Button onClick={handleCloseLINEAPI}>Cancel</Button>
                                    <Button onClick={handleSetLINEAPI}>OK</Button>
                                  </DialogActions>
                                </Dialog>
                                <Dialog
                                  PaperProps={{
                                    sx: {
                                      width: "100%",
                                      height: "80vh"
                                    }
                                  }}
                                  open={openShareClient} onClose={handleCloseShareClient}>
                                  <DialogTitle>Share LPG Device to other Client</DialogTitle>
                                  <DialogContent>
                                    <DialogContentText>
                                      Enter client email to share this LPG device to. The client will only be able to view status of this device.
                                    </DialogContentText>
                                    &nbsp;
                                    {isAdmin ? (
                                      <Autocomplete
                                      disablePortal
                                      id="combo-box-demo"
                                      options={clients}
                                      onChange={handleShareClientChange}
                                      sx={{ width: "100%" }}
                                      renderInput={(params) => <TextField {...params} label="Enter Client email" />}
                                    />
                                    ):(
                                      <TextField
                                        style={{
                                          width:'100%'
                                        }}
                                       id="outlined-basic" label="Enter Client Email" variant="outlined"
                                       onChange={(e) => handleShareClientByOwnerChange(e)}
                                        />
                                    )}
                                    
                                    <List>
                                    {
                                      deviceShares && (
                                        deviceShares.map(client => {
                                          return <div><ListItem
                                          secondaryAction={
                                            <Tooltip title="Remove client from sharing this device" arrow>
                                            <IconButton edge="end" aria-label="delete" onClick={handleOpenDeleteClientFromDeviceShares}>
                                              <DeleteIcon />
                                            </IconButton>
                                            </Tooltip>
                                          }
                                        >
                                          <ListItemAvatar>
                                            <Avatar>
                                              <PersonIcon />
                                            </Avatar>
                                          </ListItemAvatar>
                                          <ListItemText
                                            primary={client.title}
                                            secondary={client.username}
                                          />
                                        </ListItem>
                                        <Dialog
                                          open={openDeleteClientFromDeviceShares}
                                          onClose={handleCloseDeleteClientFromDeviceShares}
                                          aria-labelledby="alert-dialog-title"
                                          aria-describedby="alert-dialog-description"
                                        >
                                          <DialogTitle id="alert-dialog-title">
                                            {"Delete client \'" + client.title + "\' from sharing this device?"}
                                          </DialogTitle>
                                          <DialogContent>
                                            <DialogContentText id="alert-dialog-description">
                                              This will remove client from the list of sharing this device. The removing client will not be able to view this device information.
                                            </DialogContentText>
                                          </DialogContent>
                                          <DialogActions>
                                            <Button onClick={handleCloseDeleteClientFromDeviceShares}>Cancel</Button>
                                            <Button onClick={(e) => handleDeleteClientFromDeviceShares(client.id)} autoFocus>
                                              Delete
                                            </Button>
                                          </DialogActions>
                                        </Dialog>
                                          </div>
                                        })
                                      )
                                    }
                                    </List>
                                  </DialogContent>
                                  <DialogActions>
                                    <Button onClick={handleCloseShareClient}>Close</Button>
                                    <Button onClick={handleShareClient}>Share</Button>
                                  </DialogActions>
                                </Dialog>

                                <Dialog
                                  PaperProps={{
                                    sx: {
                                      width: "100%",
                                      //maxWidth: "800px",                                      
                                    }
                                  }}
                                  fullScreen={isSM ? true : false}
                                  open={openEmailList} onClose={handleOpenEmailList}>
                                  <DialogTitle>Config Email Template</DialogTitle>
                                  <DialogContent>
                                    <DialogContentText>
                                      Configuration for email template.
                                    </DialogContentText>                                    
                                    <Styles>
                                      <Form
                                          onSubmit={onSubmitEmailList}
                                          validate={(values) => {
                                            const errors = {};
                                            if (!values.Description) {
                                              errors.Description = "required";
                                            }
                                            if (!values.Material) {
                                              errors.Material = "required";
                                            }
                                            if (!values.MaterialDescription) {
                                              errors.MaterialDescription = "required";
                                            }
                                            if (!values.NumberRunA) {
                                              errors.NumberRunA = "required";
                                            }
                                            if (!values.NumberRunB) {
                                              errors.NumberRunB = "required";
                                            }
                                            if (!values.OrderDays) {
                                              errors.OrderDays = "required";
                                            }
                                            if (!values.PaymentTerm) {
                                              errors.PaymentTerm = "required";
                                            }
                                            if (!values.Plant) {
                                              errors.Plant = "required";
                                            }
                                            if (!values.SalesOrder) {
                                              errors.SalesOrder = "required";
                                            }
                                            if (!values.ShipTo) {
                                              errors.ShipTo = "required";
                                            }
                                            if (!values.SoldTo) {
                                              errors.SoldTo = "required";
                                            }
                                            return errors;
                                          }}
                                          initialValues={{
                                                          Description: deviceEmailConfiguration.Description,
                                                          Material: deviceEmailConfiguration.Material,
                                                          MaterialDescription: deviceEmailConfiguration.MaterialDescription,
                                                          NumberRunA: deviceEmailConfiguration.NumberRunA,
                                                          NumberRunB: deviceEmailConfiguration.NumberRunB,
                                                          OrderDays: deviceEmailConfiguration.OrderDays,
                                                          PaymentTerm: deviceEmailConfiguration.PaymentTerm,
                                                          Plant: deviceEmailConfiguration.Plant,
                                                          SalesOrder: deviceEmailConfiguration.SalesOrder,
                                                          ShipTo: deviceEmailConfiguration.ShipTo,
                                                          SoldTo: deviceEmailConfiguration.SoldTo,
                                                          emails: deviceEmailConfiguration.emails
                                                        }}
                                          mutators={{
                                            // potentially other mutators could be merged here
                                            ...arrayMutators
                                          }}
                                          render={({ 
                                            submitError,
                                            handleSubmit, 
                                            form: {
                                            mutators: { push, pop }
                                              }, 
                                            form, 
                                            submitting, 
                                            pristine, 
                                            values }) => (
                                              <form onSubmit={handleSubmit}>
                                                
                                                <Field name="Description">
                                                  {({ input, meta }) => (
                                                    <div>
                                                      <label>Description</label>
                                                      <input {...input} type="text" placeholder="Food Hub" />
                                                      {(meta.error || meta.submitError) && meta.touched && (
                                                        <span>{meta.error || meta.submitError}</span>
                                                      )}
                                                    </div>
                                                  )}
                                                </Field>
                                                <Field name="Material">
                                                  {({ input, meta }) => (
                                                    <div>
                                                      <label>Material</label>
                                                      <input {...input} type="text" placeholder="400011" />
                                                      {(meta.error || meta.submitError) && meta.touched && (
                                                        <span>{meta.error || meta.submitError}</span>
                                                      )}
                                                    </div>
                                                  )}
                                                </Field>
                                                <Field name="MaterialDescription">
                                                  {({ input, meta }) => (
                                                    <div>
                                                      <label>Material Description</label>
                                                      <input {...input} type="text" placeholder="ถัง 48 กก L/W 2 วาล์ว" />
                                                      {(meta.error || meta.submitError) && meta.touched && (
                                                        <span>{meta.error || meta.submitError}</span>
                                                      )}
                                                    </div>
                                                  )}
                                                </Field>
                                                <Field name="NumberRunA">
                                                  {({ input, meta }) => (
                                                    <div>
                                                      <label>Number Run A</label>
                                                      <input {...input} type="text" placeholder="10" />
                                                      {(meta.error || meta.submitError) && meta.touched && (
                                                        <span>{meta.error || meta.submitError}</span>
                                                      )}
                                                    </div>
                                                  )}
                                                </Field>  
                                                <Field name="NumberRunB">
                                                  {({ input, meta }) => (
                                                    <div>
                                                      <label>Number Run B</label>
                                                      <input {...input} type="text" placeholder="10" />
                                                      {(meta.error || meta.submitError) && meta.touched && (
                                                        <span>{meta.error || meta.submitError}</span>
                                                      )}
                                                    </div>
                                                  )}
                                                </Field>  
                                                <Field name="OrderDays">
                                                  {({ input, meta }) => (
                                                    <div>
                                                      <label>Order Days</label>
                                                      <input {...input} type="text" placeholder="1" />
                                                      {(meta.error || meta.submitError) && meta.touched && (
                                                        <span>{meta.error || meta.submitError}</span>
                                                      )}
                                                    </div>
                                                  )}
                                                </Field>  
                                                <Field name="PaymentTerm">
                                                  {({ input, meta }) => (
                                                    <div>
                                                      <label>Payment Term</label>
                                                      <input {...input} type="text" placeholder="YB21" />
                                                      {(meta.error || meta.submitError) && meta.touched && (
                                                        <span>{meta.error || meta.submitError}</span>
                                                      )}
                                                    </div>
                                                  )}
                                                </Field>  
                                                <Field name="Plant">
                                                  {({ input, meta }) => (
                                                    <div>
                                                      <label>Plant</label>
                                                      <input {...input} type="text" placeholder="J141" />
                                                      {(meta.error || meta.submitError) && meta.touched && (
                                                        <span>{meta.error || meta.submitError}</span>
                                                      )}
                                                    </div>
                                                  )}
                                                </Field>  
                                                <Field name="SalesOrder">
                                                  {({ input, meta }) => (
                                                    <div>
                                                      <label>Sales Order</label>
                                                      <input {...input} type="text" placeholder="Order Number 1" />
                                                      {(meta.error || meta.submitError) && meta.touched && (
                                                        <span>{meta.error || meta.submitError}</span>
                                                      )}
                                                    </div>
                                                  )}
                                                </Field>  
                                                <Field name="ShipTo">
                                                  {({ input, meta }) => (
                                                    <div>
                                                      <label>Ship To</label>
                                                      <input {...input} type="text" placeholder="10029980" />
                                                      {(meta.error || meta.submitError) && meta.touched && (
                                                        <span>{meta.error || meta.submitError}</span>
                                                      )}
                                                    </div>
                                                  )}
                                                </Field>
                                                <Field name="SoldTo">
                                                  {({ input, meta }) => (
                                                    <div>
                                                      <label>Sold To</label>
                                                      <input {...input} type="text" placeholder="10039980" />
                                                      {(meta.error || meta.submitError) && meta.touched && (
                                                        <span>{meta.error || meta.submitError}</span>
                                                      )}
                                                    </div>
                                                  )}
                                                </Field>

                                              <div className="buttons">
                                                <button
                                                  type="button"
                                                  onClick={() => push('emails', undefined)}
                                                >
                                                  Add Email
                                                </button>
                                                <button type="button" onClick={() => pop('emails')}>
                                                  Remove Email
                                                </button>
                                              </div>
                                              <FieldArray name="emails">
                                                {({ fields }) =>
                                                  fields.map((name, index) => (
                                                    <div key={name}>
                                                      <label>Email #{index + 1}</label>
                                                      <Field
                                                        name={`${name}.email`}
                                                        component="input"
                                                        placeholder="nobody@company.com"
                                                      />
                                                      <span
                                                        onClick={() => fields.remove(index)}
                                                        style={{ cursor: 'pointer' }}
                                                      >
                                                        ❌
                                                      </span>
                                                    </div>
                                                  ))
                                                }
                                              </FieldArray>
                                              
                                              <div className="buttons">
                                                  <button type="submit" disabled={submitting || pristine}>
                                                      Save
                                                  </button>
                                                  <button
                                                  type="button"
                                                  onClick={form.reset}
                                                  disabled={submitting || pristine}
                                                  >
                                                  Reset
                                                  </button>
                                                  <button
                                                  type="button"
                                                  onClick={handleCloseEmailList}
                                                  >
                                                  Cancel
                                                  </button>
                                              </div>
                                              {/*<pre>{JSON.stringify(values, 0, 2)}</pre>*/}
                                              </form>
                                          )}
                                          />
                                          </Styles>
                                  </DialogContent>
                                </Dialog>

                                <Snackbar
                                  open={openShareSnackbar}
                                  autoHideDuration={6000}
                                  onClose={handleCloseShareSnackbar}
                                  message={shareSnackbarMessage}
                                />
                                <Dialog
                                  PaperProps={{
                                    sx: {
                                      width: "100%",
                                      height: "80vh"
                                    }
                                  }}
                                  open={openAssignClient} onClose={handleCloseAssignClient}>
                                  <DialogTitle>Assign LPG Device to Client</DialogTitle>
                                  <DialogContent>
                                    <DialogContentText>
                                      Enter client email to assign this LPG device to. Only client with 'store' user type can own the LPG device. The client will be the owner of this device and have rights to manage this device upon the authorization level. The previous owner of this device will be removed from this device.
                                    </DialogContentText>
                                    &nbsp;
                                    <Autocomplete
                                      disablePortal
                                      id="combo-box-demo"
                                      options={clients.filter(function(client) {
                                        return client.type == 'store';
                                      })}
                                      onChange={handleClientChange}
                                      sx={{ width: "100%" }}
                                      renderInput={(params) => <TextField {...params} label="Client email" />}
                                    />
                                  </DialogContent>
                                  <DialogActions>
                                    <Button onClick={handleCloseAssignClient}>Cancel</Button>
                                    <Button onClick={handleAssignClient}>Assign</Button>
                                  </DialogActions>
                                </Dialog>
                                <Dialog
                                    open={openDeleteConfirm}
                                    onClose={handleCloseDeleteConfirm}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                                >
                                    <DialogTitle id="alert-dialog-title">
                                    {"Delete device \"" + device.title + "\"?"}
                                    </DialogTitle>
                                    <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        Delete this device will remove device from database and also delist it from associated clients who are using this device (both viewing and sharing). This cannot be undone!!
                                    </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                    <Button onClick={handleCloseDeleteConfirm}>Cancel</Button>
                                    <Button onClick={handleConfirmDelete} autoFocus>
                                        Delete
                                    </Button>
                                    </DialogActions>
                                </Dialog>
                                <Snackbar
                                  open={openDeleteSnackbar}
                                  autoHideDuration={6000}
                                  onClose={handleCloseDeleteSnackbar}
                                  message={deleteSnackbarMessage}
                                />
                              </Grid>                              
                            </Grid>
                          </Grid>
                          <Grid item xs={4}>
                            <Card elevation={0}>
                              <CardContent>
                                <Grid container justifyContent={"center"}>
                                <DeviceStatus deviceId={deviceId} showTitle={false} scale={1.1} shared={(device.client.id == uid) ? "false" : "true"} />
                                </Grid>
                              </CardContent>
                            </Card>
                          </Grid> 
                          </Grid>
                            <Grid item xs={12}>
                              {device.type === 'tank' ? (
                                getTankDisplay2()
                                ):(
                                  getLPGDisplay2()
                                )}
                            </Grid>
                        </Grid>
                    <Grid item xs={12} md={7}>
                            <Stack direction="column" spacing={1}>
                              {/*{(moment(selectEndChartDate).isSame(moment(), 'day') ? <DeviceChartToday deviceId={deviceId} type={device.type} date={moment(selectStartChartDate).format("MMM DD, yyyy")} enddate={moment(selectEndChartDate).format("MMM DD, yyyy")}/> : <DeviceChart deviceId={deviceId} type={device.type} date={moment(selectStartChartDate).format("MMM DD, yyyy")} enddate={moment(selectEndChartDate).format("MMM DD, yyyy")}/>)}*/}
                              <DeviceChart deviceId={deviceId} type={device.type} date={selectStartChartDate} enddate={selectEndChartDate} daterange={chartDateRange} deviceInfo={device.sensor_info} />
                              {/*<Stack direction="row">
                              <DatePicker 
                                  id="start-date"
                                  label={"LPG Status Start Date"}
                                  value={selectStartChartDate} 
                                  inputFormat="MMM DD, yyyy"
                                  onChange={(selectedDate) => {
                                    setSelectStartChartDate(selectedDate);
                                  }} 
                                  disableFuture
                                  renderInput={props => <TextField {...props}/>}
                                />
                                <DatePicker 
                                  id="end-date"
                                  label={"LPG Status End Date"}
                                  value={selectEndChartDate} 
                                  inputFormat="MMM DD, yyyy"
                                  onChange={(selectedDate) => {
                                    setSelectEndChartDate(selectedDate);
                                  }} 
                                  disableFuture
                                  renderInput={props => <TextField {...props}/>}
                                />
                                </Stack>*/}
                                {isMD ? (
                                  <DateRange                             
                                  onChange={item => {
                                    setChartDateRange([item.selection]);
                                    setSelectStartChartDate(moment(item.selection.startDate.toLocaleDateString()))
                                    setSelectEndChartDate(moment(item.selection.endDate.toLocaleDateString()))
                                  }}
                                  minDate={addDays(new Date(), -180)}
                                  maxDate={new Date()}
                                  showSelectionPreview={true}
                                  moveRangeOnFirstSelection={false}
                                  months={2}
                                  preventSnapRefocus={true}
                                  calendarFocus="backwards"
                                  ranges={chartDateRange}
                                  direction={isSM ? "vertical" : "horizontal"}
                                />
                                ):(
                                  <DateRangePicker                             
                                  onChange={item => {
                                    setChartDateRange([item.selection]);
                                    setSelectStartChartDate(moment(item.selection.startDate.toLocaleDateString()))
                                    setSelectEndChartDate(moment(item.selection.endDate.toLocaleDateString()))
                                  }}
                                  minDate={addDays(new Date(), -180)}
                                  maxDate={new Date()}
                                  showSelectionPreview={true}
                                  moveRangeOnFirstSelection={false}
                                  months={2}
                                  preventSnapRefocus={true}
                                  calendarFocus="backwards"
                                  ranges={chartDateRange}
                                  direction={"horizontal"}
                                />
                                )}
                                
                            </Stack>
                          </Grid>
                            {device.type === 'tank' ? (
                              getTankDisplay()
                            ):(
                              getLPGDisplay()
                            )}
                      </Grid>
                    </Paper>)}

                  {currentTabIndex === 1 && (
                    <Grid container spacing={1}>
                      <Grid item xs={12} md={12}>
                      <Styles>
                      <Form
                        onSubmit={onSubmitDeviceManagement}
                        initialValues={{deviceName: deviceTitle, deviceId: deviceId ,ownerName: clientTitle, note: deviceManagement.note, installationDate: dayjs(deviceManagement.installation_date),
                        dueDate: dayjs(deviceManagement.due_date),
                        paymentDate: dayjs(deviceManagement.payment_date)}}
                        render={({ handleSubmit, form, submitting, pristine, values }) => (
                          <form onSubmit={handleSubmit}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>

                            <div>
                              <label>Device Name</label>
                              <Field
                                name="deviceName"
                                component="input"
                                type="text"
                                placeholder="Device Name"
                                disabled
                              />
                            </div>
                            <div>
                              <label>Device ID</label>
                              <Field
                                name="deviceId"
                                component="input"
                                type="text"
                                placeholder="Device ID"
                                disabled
                              />
                            </div>
                            <div>
                              <label>Owner</label>
                              <Field
                                name="ownerName"
                                component="input"
                                type="text"
                                placeholder="Owner Name"
                                disabled
                              />
                            </div>
                            <div>
                            <label>Installation Date</label>
                            <Field name="installationDate">
                            {({ input, meta }) => (
                                <DatePicker
                                  value={input.value}
                                  onChange={(newValue) => {
                                    if (newValue === null) {
                                      input.onChange(null);
                                    } else {
                                      input.onChange(newValue);
                                    }
                                    console.log(newValue);
                                  }}
                                  format="MMMM DD, YYYY"
                                />
                              )}
                            </Field>
                            </div>
                            <div>
                            <label>Due Date</label>
                            <Field name="dueDate" validate={mustBeValidDateTime}>
                              {({ input, meta }) => (
                                <DatePicker
                                  clerable={true}
                                  value={input.value}
                                  onChange={(newValue) => {
                                    if (newValue === null) {
                                      input.onChange(null);
                                    } else {
                                      input.onChange(newValue);
                                    }
                                    //console.log(newValue);
                                  }}
                                  format="MMMM DD, YYYY"
                                />
                              )}
                            </Field>
                            </div>
                            <div>
                            <label>Payment Date</label>
                            <Field name="paymentDate" validate={mustBeValidDateTime}>
                              {({ input, meta }) => (
                                <DatePicker
                                  clerable={true}
                                  value={input.value}
                                  onChange={(newValue) => {
                                    if (newValue === null) {
                                      input.onChange(null);
                                    } else {
                                      input.onChange(newValue);
                                    }
                                    //console.log(newValue);
                                  }}
                                  format="MMMM DD, YYYY"
                                />
                              )}
                            </Field>
                            </div>
                            <div>
                              <label>Note</label>
                              <Field name="note" component="textarea" placeholder="Note" />
                            </div>
                            <div className="buttons">
                              <button type="submit" disabled={submitting || pristine}>
                                Update
                              </button>
                              <button
                                type="button"
                                onClick={form.reset}
                                disabled={submitting || pristine}
                              >
                                Reset
                              </button>
                            </div>
                            {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
                            </LocalizationProvider>
                          </form>
                        )}
                      />
                      </Styles>
                      </Grid>
                    </Grid>
                  )}

                    <Grid container spacing={2} sx={{p: 4}}>
                    <Grid item xs={12}></Grid> 
                </Grid>
                
            </Container>
  }
}

const getTankDisplay = () =>
{
      return <Grid 
              container 
              spacing={1} 
              sx={{p: 2}} 
              direction={"row"}
              justifyContent={"center"}>
                <Grid item xs={12} md={6}>
                  <Accordion defaultExpanded={false}>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-level"
                      >
                        <Typography>{device.sensor_info.level.title}</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                      <Grid container>
                        <Grid item xs={12} md={6} >
                          <Box display="flex" justifyContent="center">
                            <Level id="level" value={device.current_status.weight} title={device.sensor_info.level.title} desc={device.sensor_info.level.desc} status={device.current_status.level.status} trend={device.current_status.level.trend} value_kg={parseFloat(device.current_status.weight)*parseFloat(device.sensor_info.level.full_tank)/100} disabled={device.sensor_info.level.hardware_status=='not_installed'}/>
                          </Box>
                        </Grid>
                          <Grid item xs={12} md={6}>
                            <Box display="flex" justifyContent="center">
                              <LevelSetting deviceId={deviceId}  hardware_status={device.sensor_info.level.hardware_status} full_level={device.sensor_info.level.full_level} full_tank={device.sensor_info.level.full_tank}
                            min_level={device.sensor_info.level.min_level}
                            warning_threshold={device.sensor_info.level.warning_threshold}/>
                            </Box>
                          </Grid>
                        </Grid>
                    </AccordionDetails>
                  </Accordion>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Accordion defaultExpanded={false}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-vaporizer"
                        >
                          <Typography>{device.sensor_info.vaporizer.title}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Grid container>
                            <Grid item xs={12} md={6}>
                              <Box display="flex" justifyContent="center" alignItems="center" height={286}>
                                <Vaporizer sx={{p:4}} id="vaporizer" value={device.current_status.vaporizer.fail_state} title={device.sensor_info.vaporizer.title} desc={device.sensor_info.vaporizer.desc} disabled={device.sensor_info.vaporizer.hardware_status=="not_installed"}/>
                                </Box>
                              </Grid>
                            <Grid item xs={12} md={6}>
                              <Box display="flex" justifyContent="center">  
                                <VaporizerSetting deviceId={deviceId}  hardware_status={device.sensor_info.vaporizer.hardware_status} />
                              </Box>
                            </Grid>
                          </Grid>
                        </AccordionDetails>
                      </Accordion>                    
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Accordion defaultExpanded={false}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-g1"
                        >
                          <Typography>{device.sensor_info.gas_leak.g1.title}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Grid container>
                            <Grid item xs={12} md={6}>
                              <Box display="flex" justifyContent="center">
                                <GasLeak id="gasleak" value={device.current_status.gas_leakage} title={device.sensor_info.gas_leak.g1.title} desc={device.sensor_info.gas_leak.g1.desc} status={device.current_status.events.gas_leak} disabled={device.sensor_info.gas_leak.g1.hardware_status=="not_installed"}/>
                                </Box>
                              </Grid>
                            <Grid item xs={12} md={6}>
                              <Box display="flex" justifyContent="center">
                                <GasLeakSetting deviceId={deviceId}  hardware_status={device.sensor_info.gas_leak.g1.hardware_status} max_value={device.sensor_info.gas_leak.g1.max_value} />
                              </Box>
                            </Grid>
                          </Grid>
                        </AccordionDetails>
                      </Accordion>
                    </Grid>
                    <Grid item xs={12} md={6}>
                    <Accordion defaultExpanded={false}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-t1"
                        >
                          <Typography>{device.sensor_info.temperature.t1.title}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                        <Grid container>
                        <Grid item xs={12} md={6}>
                          <Box display="flex" justifyContent="center">
                            <Temp id="temp" value={device.current_status.temp} title={device.sensor_info.temperature.t1.title} desc={device.sensor_info.temperature.t1.desc} status={device.current_status.events.temp_over} disabled={device.sensor_info.temperature.t1.hardware_status=="not_installed"}/>
                            </Box>
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <Box display="flex" justifyContent="center" >
                              <TemperatureSetting deviceId={deviceId}  hardware_status={device.sensor_info.temperature.t1.hardware_status} max_value={device.sensor_info.temperature.t1.max_value} />
                            </Box>
                          </Grid>
                        </Grid>
                    </AccordionDetails>
                  </Accordion>
              </Grid>
            </Grid>
}

const getLPGDisplay = () =>
{
    return <Grid 
            container 
            sx={{pt: 2}} 
            rowSpacing={1}
            columnSpacing={1}
            direction={"row"}
            justifyContent={"center"}>
                <Grid item xs={12} md={6}>
                    <Accordion defaultExpanded={false}>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-p1"
                      >
                        <Typography>{device.sensor_info.pressure.p1.title}</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                            <Grid container>
                              <Grid item xs={12} md={6}>
                                <Box display="flex" justifyContent="center" alignItems="center">
                                <Pressure id="p1" value={device.current_status.pressures.p1.value} active={(device.current_status.gas_active=="A") || (device.current_status.gas_active=="AB")} title={device.sensor_info.pressure.p1.title} desc={device.sensor_info.pressure.p1.desc} status={device.current_status.pressures.p1.status} trend={device.current_status.pressures.p1.trend} disabled={device.sensor_info.pressure.p1.hardware_status=="not_installed"}/>
                                </Box>
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Box display="flex" justifyContent="center">
                                <PressureSetting id="p1" deviceId={deviceId} hardware_status={device.sensor_info.pressure.p1.hardware_status} max_rate={device.sensor_info.pressure.p1.max_rate} max_value={device.sensor_info.pressure.p1.max_value} min_value={device.sensor_info.pressure.p1.min_value} />
                                </Box>
                              </Grid>
                            </Grid>
                      </AccordionDetails>
                    </Accordion>
                  </Grid>
                  <Grid item xs={12} md={6}>
                  <Accordion defaultExpanded={false}>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-p2"
                      >
                        <Typography>{device.sensor_info.pressure.p2.title}</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Grid container>
                          <Grid item xs={12} md={6}>
                            <Box display="flex" justifyContent="center">
                              <Pressure id="p2" value={device.current_status.pressures.p2.value} active={(device.current_status.gas_active=="B") || (device.current_status.gas_active=="AB")} title={device.sensor_info.pressure.p2.title} desc={device.sensor_info.pressure.p2.desc} status={device.current_status.pressures.p2.status} trend={device.current_status.pressures.p2.trend} disabled={device.sensor_info.pressure.p2.hardware_status=="not_installed"}/>
                              </Box>
                            </Grid>
                          <Grid item xs={12} md={6}>
                            <Box display="flex" justifyContent="center">
                              <PressureSetting id="p2" deviceId={deviceId}  hardware_status={device.sensor_info.pressure.p2.hardware_status} max_rate={device.sensor_info.pressure.p2.max_rate} max_value={device.sensor_info.pressure.p2.max_value} min_value={device.sensor_info.pressure.p2.min_value}/>
                            </Box>
                          </Grid>
                          </Grid>
                    </AccordionDetails>
                    </Accordion>
            </Grid>
            <Grid item xs={12} md={6}>      
                <Accordion defaultExpanded={false}>
                    <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-g1"
                        >
                        <Typography>{device.sensor_info.gas_leak.g1.title}</Typography>
                    </AccordionSummary>
                        <AccordionDetails>
                          <Grid container>
                            <Grid item xs={12} md={6}>
                              <Box display="flex" justifyContent="center">
                                <GasLeak id="gasleak" value={device.current_status.gas_leakage} title={device.sensor_info.gas_leak.g1.title} desc={device.sensor_info.gas_leak.g1.desc} status={device.current_status.events.gas_leak} disabled={device.sensor_info.gas_leak.g1.hardware_status=="not_installed"}/>
                                </Box>
                              </Grid>
                            <Grid item xs={12} md={6}>
                              <Box display="flex" justifyContent="center" alignSelf="center">  
                                <GasLeakSetting deviceId={deviceId}  hardware_status={device.sensor_info.gas_leak.g1.hardware_status} max_value={device.sensor_info.gas_leak.g1.max_value} />
                                </Box>
                              </Grid>
                          </Grid>
                        </AccordionDetails>
                      </Accordion>
                  </Grid>
                <Grid item xs={12} md={6}>
                    <Accordion defaultExpanded={false}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-t1"
                        >
                          <Typography>{device.sensor_info.temperature.t1.title}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                        <Grid container>
                        <Grid item xs={12} md={6} >
                          <Box display="flex" justifyContent="center"> 
                            <Temp id="temp" value={device.current_status.temp} title={device.sensor_info.temperature.t1.title} desc={device.sensor_info.temperature.t1.desc} status={device.current_status.events.temp_over} disabled={device.sensor_info.temperature.t1.hardware_status=="not_installed"}/>
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Box display="flex" justifyContent="center"> 
                              <TemperatureSetting deviceId={deviceId}  hardware_status={device.sensor_info.temperature.t1.hardware_status} max_value={device.sensor_info.temperature.t1.max_value} />
                            </Box>
                          </Grid>
                        </Grid>
                    </AccordionDetails>
                  </Accordion>
            </Grid>
            <Grid item xs={12} md={6}>    
                  <Accordion defaultExpanded={false}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-r1"
                        >
                          <Typography>{device.sensor_info.relay.r1.title}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                        <Grid container>
                        <Grid item xs={12} md={6}>
                        <Box display="flex" justifyContent="center"> 
                          <Heat id="r1" value={device.current_status.relays.r1.value} title={device.sensor_info.relay.r1.title} desc={device.sensor_info.relay.r1.desc} disabled={device.sensor_info.relay.r1.hardware_status=="not_installed"}/>
                          </Box>
                          </Grid>
                          <Grid item xs={12} md={6}>
                          <Box display="flex" justifyContent="center"> 
                            <HeatSetting id="r1" deviceId={deviceId} hardware_status={device.sensor_info.relay.r1.hardware_status}  />
                            </Box>
                          </Grid>
                        </Grid>
                    </AccordionDetails>
                    </Accordion>
                  </Grid>
                  <Grid item xs={12} md={6}>
                  <Accordion defaultExpanded={false}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-r2"
                        >
                          <Typography>{device.sensor_info.relay.r2.title}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                        <Grid container>
                        <Grid item xs={12} md={6}>
                          <Box display="flex" justifyContent="center">
                            <Heat id="r2" value={device.current_status.relays.r2.value} title={device.sensor_info.relay.r2.title} desc={device.sensor_info.relay.r2.desc} disabled={device.sensor_info.relay.r2.hardware_status=="not_installed"}/>
                            </Box>
                          </Grid>
                          <Grid item xs={12} md={6}>
                          <Box display="flex" justifyContent="center">
                            <HeatSetting id="r2" deviceId={deviceId} hardware_status={device.sensor_info.relay.r2.hardware_status} />
                            </Box>
                          </Grid>
                        </Grid>
                    </AccordionDetails>
                </Accordion>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Accordion defaultExpanded={false}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-vaporizer"
                        >
                          <Typography>{device.sensor_info.vaporizer.title}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Grid container>
                            <Grid item xs={12} md={6}>
                              <Box display="flex" justifyContent="center" alignItems="center" height={286}>
                                <Vaporizer sx={{p:4}} id="vaporizer" value={device.current_status.vaporizer.fail_state} title={device.sensor_info.vaporizer.title} desc={device.sensor_info.vaporizer.desc} disabled={device.sensor_info.vaporizer.hardware_status=="not_installed"}/>
                                </Box>
                              </Grid>
                            <Grid item xs={12} md={6}>
                              <Box display="flex" justifyContent="center">  
                                <VaporizerSetting deviceId={deviceId}  hardware_status={device.sensor_info.vaporizer.hardware_status} />
                              </Box>
                            </Grid>
                          </Grid>
                        </AccordionDetails>
                      </Accordion>                    
                  </Grid>
                  <Grid item xs={12} md={6}></Grid>
          </Grid>
}

const getTankDisplay2 = () =>
{
      return <Grid 
              container 
              spacing={1} 
              width="auto"
              direction={"row"}
              sx={{pt: 2}}
              justifyContent={"center"}>
              <Paper sx={{width: "100%", p:1}}>
                <Grid item xs={12}>
                          <Box display="flex" justifyContent="space-around" alignItems={"center"}>
                            <Level id="level" value={device.current_status.weight} title={device.sensor_info.level.title} desc={device.sensor_info.level.desc} status={device.current_status.level.status} trend={device.current_status.level.trend} value_kg={parseFloat(device.current_status.weight)*parseFloat(device.sensor_info.level.full_tank)/100} disabled={device.sensor_info.level.hardware_status=='not_installed'}/>                          
                            <Vaporizer sx={{p:4}} id="vaporizer" value={device.current_status.vaporizer.fail_state} title={device.sensor_info.vaporizer.title} desc={device.sensor_info.vaporizer.desc} disabled={device.sensor_info.vaporizer.hardware_status=="not_installed"}/>
                            </Box>
                </Grid>
                  <Grid item xs={12}>
                              <Box display="flex" justifyContent="space-around" alignItems={"center"}>
                                <GasLeak id="gasleak" value={device.current_status.gas_leakage} title={device.sensor_info.gas_leak.g1.title} desc={device.sensor_info.gas_leak.g1.desc} status={device.current_status.events.gas_leak} disabled={device.sensor_info.gas_leak.g1.hardware_status=="not_installed"}/>
                                <Temp id="temp" value={device.current_status.temp} title={device.sensor_info.temperature.t1.title} desc={device.sensor_info.temperature.t1.desc} status={device.current_status.events.temp_over} disabled={device.sensor_info.temperature.t1.hardware_status=="not_installed"}/>
                                </Box>
                    </Grid>
                    </Paper>
            </Grid>
}

const getLPGDisplay2 = () =>
{
    return <Grid 
            container 
            sx={{p: 0}} 
            rowSpacing={0}
            columnSpacing={1}
            direction={"row"}
            justifyContent={"center"}>
            <Paper sx={{width: "100%", p:2}}>
                <Grid item xs={12}>
                  <Box display="flex" justifyContent="space-around" alignItems={"center"}>
                              <Pressure id="p1" value={device.current_status.pressures.p1.value} active={(device.current_status.gas_active=="A") || (device.current_status.gas_active=="AB")} title={device.sensor_info.pressure.p1.title} desc={device.sensor_info.pressure.p1.desc} status={device.current_status.pressures.p1.status} trend={device.current_status.pressures.p1.trend} disabled={device.sensor_info.pressure.p1.hardware_status=="not_installed"} />
                              <Pressure id="p2" value={device.current_status.pressures.p2.value} active={(device.current_status.gas_active=="B") || (device.current_status.gas_active=="AB")} title={device.sensor_info.pressure.p2.title} desc={device.sensor_info.pressure.p2.desc} status={device.current_status.pressures.p2.status} trend={device.current_status.pressures.p2.trend} disabled={device.sensor_info.pressure.p2.hardware_status=="not_installed"}/>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                   <Paper sx={{width: "100%"}}>
                    <Box display="flex" justifyContent="space-evenly" alignItems={"center"} flexWrap={"wrap"}>
                      <Typography>Gas Active</Typography>
                      
                      <ToggleButtonGroup
                        color="primary"
                        value={gasActiveCommand}
                        exclusive
                        onChange={handleGasActiveCommand}
                        aria-label="Platform"
                        sx={{p: 1}}
                      >
                        <ToggleButton value="A">A</ToggleButton>
                        <ToggleButton value="B">B</ToggleButton>
                        <ToggleButton value="AB">A & B</ToggleButton>
                        <ToggleButton value="OFF">OFF</ToggleButton>
                      </ToggleButtonGroup> 
                    </Box>
                  </Paper>
                </Grid>
                
              <Grid item xs={12}>      
                <Box display="flex" justifyContent="space-around" alignItems={"center"}>
                                <GasLeak id="gasleak" value={device.current_status.gas_leakage} title={device.sensor_info.gas_leak.g1.title} desc={device.sensor_info.gas_leak.g1.desc} status={device.current_status.events.gas_leak} disabled={device.sensor_info.gas_leak.g1.hardware_status=="not_installed"}/>
                                
                
                            <Temp id="temp" value={device.current_status.temp} title={device.sensor_info.temperature.t1.title} desc={device.sensor_info.temperature.t1.desc} status={device.current_status.events.temp_over} disabled={device.sensor_info.temperature.t1.hardware_status=="not_installed"} />
                          </Box>
              </Grid>
              <Grid item xs={12}>    
                <Box display="flex" justifyContent="space-around" alignItems={"center"}>
                  <Heat id="r1" value={device.current_status.relays.r1.value} title={device.sensor_info.relay.r1.title} desc={device.sensor_info.relay.r1.desc} disabled={device.sensor_info.relay.r1.hardware_status=="not_installed"}/>                          
                  <Heat id="r2" value={device.current_status.relays.r2.value} title={device.sensor_info.relay.r2.title} desc={device.sensor_info.relay.r2.desc} disabled={device.sensor_info.relay.r2.hardware_status=="not_installed"}/>
                </Box>                          
              </Grid>
              <Grid item xs={12} md={6}>
                <Box sx={{mt: 5}} display="flex" justifyContent="space-around" alignItems={"center"}>
                  <Vaporizer sx={{p:4}} id="vaporizer" value={device.current_status.vaporizer.fail_state} title={device.sensor_info.vaporizer.title} desc={device.sensor_info.vaporizer.desc} disabled={device.sensor_info.vaporizer.hardware_status=="not_installed"}/>
                </Box>  
              </Grid>
            <Grid item xs={12}>
              <Divider sx={{mt: 2}}></Divider>
              <Box sx={{p: 1, display: 'flex', justifyContent: 'flex-end'}}><Typography variant="caption">Last updated::  </Typography><Typography sx={{fontStyle: 'italic'}} variant="caption">{moment(device.log_timestamp).fromNow()}</Typography></Box>
            </Grid>
            </Paper>
          </Grid>
}

const displayActivateStatus = () => {
  if(device.status.activated == "true")
  {
    return <Chip disabled={sessionStorage.getItem('power_user')=="false"} label="activated" color="warning" onClick={handleClickActivate} />
  }
  else
  {
    return <Chip disabled={sessionStorage.getItem('power_user')=="false"} label="deactivated" onClick={handleClickActivate} />
  }
}



const handleClickActivate = () => {
  if(device.status.activated == "true")
  {
    firebase_update_device_status(deviceId, { activated: "false"});
  }
  else
  {
    firebase_update_device_status(deviceId, { activated: "true"});
  }
  
}

const displayEmailStatus = () => {
  if(device.status.email == "true")
  {
    return <>
              <Chip disabled={sessionStorage.getItem('power_user')=="false"} label="email" color="warning" onClick={handleClickEmail} />
              <Button 
                disabled={!(sessionStorage.getItem("power_user") == "true")}
                onClick={handleOpenEmailList} color="success" variant="outline" size="small" startIcon={<ContactMailIcon /> }>
                Email
            </Button>
            </>
  }
  else
  {
    return <Chip disabled={sessionStorage.getItem('power_user')=="false"} label="no email" onClick={handleClickEmail} />
  }
}

const handleOpenEmailList = async () => {
  // load email data from firebase
  var email_con = {};
  email_con = await firebase_get_email_configuration(deviceId);
  if(Object.keys(email_con).length === 0)
  {
    // no data 
    setOpenEmailList(true);
  }
  else
  {
    // already have data
    setDeviceEmailConfiguration(email_con);
    setOpenEmailList(true);
  }
}

const handleCloseEmailList = () => {
  setOpenEmailList(false)
}

const handleClickEmail = () => {
  if(device.status.email == "true")
  {
    firebase_update_device_status(deviceId, { email: "false"});
  }
  else
  {
    firebase_update_device_status(deviceId, { email: "true"});
  }
  
}

const displayOnlineStatus = () => {
  if(device.status.online == "true")
  {
    return <Chip disabled={sessionStorage.getItem('power_user')=="false"} label="online" color="info" onClick={handleClickOnline}/>
  }
  else
  {
    return <Chip disabled={sessionStorage.getItem('power_user')=="false"} label="offline" onClick={handleClickOnline} />
  }
}

const handleClickOnline = () => {
  if(device.status.online == "true")
  {
    firebase_update_device_status(deviceId, { online: "false"});
  }
  else
  {
    firebase_update_device_status(deviceId, { online: "true"});
  }
  
}

  return (<div className="container">  
            {
              device ? (
                <Paper elevation={0}>
                  {displayDevice()}
                  
                </Paper>
              ):
              (
                <></>
              )
            } 
          </div>
        );
}

export default Device;
